import { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ServiceMarquee } from "@/components/ServiceMarquee";
import { About } from "@/components/About";
import { Categories } from "@/components/Categories";
import { Prescription } from "@/components/Prescription";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      const lenis = lenisRef.current?.lenis;
      if (lenis) {
        window.__lenis = lenis;
        clearInterval(id);
      }
    }, 60);
    return () => clearInterval(id);
  }, []);

  return (
    <ReactLenis
      root
      ref={lenisRef}
      options={{ lerp: 0.09, smoothWheel: true }}
    >
      <div className="App min-h-screen bg-white antialiased">
        <Navbar />
        <main>
          <Hero />
          <ServiceMarquee />
          <About />
          <Categories />
          <Prescription />
          <Testimonials />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <FloatingButtons />
        <Toaster position="top-center" richColors closeButton />
      </div>
    </ReactLenis>
  );
}

export default App;
